import axios, { AxiosError } from "axios"
import { requestInterceptorErrorSecurityCredentials, requestInterceptorSuccessCredentials, responseInterceptorErrorCredentials, responseInterceptorSuccessCredentials } from "interceptors"
import {
  LIST_PATH,
  USER_PATH
} from "lib"
import { IAprobarORechazar } from "model/EmialAprobarORechazar"

const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})


const intanceUsers = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const wsObtenerFileDraft = async (id: number) => {
  try {
    const result = await instance.get(`/draft-file/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const wsObtenerArchivosDraft = async (id: number) => {
  try {
    const result = await instance.get(`/draft-archivos/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const wsObtenerUsuarios = async () => {
  try {
    const result = await intanceUsers.get(USER_PATH + LIST_PATH + "/refund")
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const wsUsuarioPorId = async (id: number) => {
  try {
    const result = await intanceUsers.get(USER_PATH + "/" + id)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const wsReenviarCorreoAprobador = async (id: number) => {
  try {
    const result = await instance.get("/document/resendmail/" + id)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const wsObtenerIDAprobador = async (id: number) => {
  try {
    const result = await instance.get("/document/getaprobador/" + id)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const wsAprobarORechazarPorMail = async (request: IAprobarORechazar) => {
  try {
    const result = await instance.post("/document/manualrequest", request)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
